import initKeepAlive, { KeepAliveDTO } from "@/shared/models/keepAlive";
// 初始化 KeepAlive 的 Provieder、Hook 并暴露给需要使用的组件
const { useKeepAlive, KeepAliveProvider, KeepAliveConsumer } = initKeepAlive();

export { useKeepAlive, KeepAliveProvider, KeepAliveConsumer };
export type { KeepAliveDTO };
